import { createResourceActions } from '../@common/actions/resource-actions';
import { DIRS_LAYER_PREFIX } from './constants';

export const dirsLayerActions = {
  ...createResourceActions(DIRS_LAYER_PREFIX)
};
